"use strict";
/**
 * trsTrustHtmlModule
 *
 * Description  信任HTML
 */
angular.module('trsTrustAsResourceUrlModule', []).
filter("trsTrustAsResourceUrl", ["$sce", function($sce) {
    return function(input) {
        if (angular.isDefined(input)) {
            input = $sce.trustAsResourceUrl(input);
        }
        return input;
    }
}])
